import * as actionTypes from "../actionTypes";

export const getRoles = payload => ({
    type: actionTypes.GET_ROLES,
    payload
});

export const setRoles = payload => ({
    type: actionTypes.SET_ROLES,
    payload
});

export const createRole = payload => ({
    type: actionTypes.CREATE_ROLE,
    payload
});

export const updateRole = payload => ({
    type: actionTypes.UPDATE_ROLE,
    payload
});

export const deleteRole = payload => ({
    type: actionTypes.DELETE_ROLE,
    payload
});

export const getActivityLogs = payload => ({
    type: actionTypes.GET_ACTIVITY_LOGS,
    payload
});

export const setActivityLogs = payload => ({
    type: actionTypes.SET_ACTIVITY_LOGS,
    payload
});

export const getModules = payload => ({
    type: actionTypes.GET_MODULES,
    payload
});

export const setModules = payload => ({
    type: actionTypes.SET_MODULES,
    payload
});
